/*
 * Vayve cart effects
 * - Fly-to-cart: after add to cart, a thumbnail of the product flies to the cart icon,
 *   the icon bumps and a small "Added to cart" toast offers View cart, instead of opening
 *   the cart drawer every time. Controlled by theme setting "After add to cart".
 * - Cart drawer titles are clamped to 2 lines; the first tap on a clamped title expands it.
 */
(() => {
  if (window.CVayveCartFx) return;

  let lastTap = null;
  let lastTapAt = 0;
  document.addEventListener(
    'pointerdown',
    (e) => {
      lastTap = e.target;
      lastTapAt = Date.now();
    },
    true
  );

  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const isVisible = (el) => {
    if (!el) return false;
    const r = el.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) return false;
    const cs = getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && Number(cs.opacity) !== 0;
  };

  const inViewport = (el) => {
    const r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
  };

  function cartIcon() {
    const icons = [...document.querySelectorAll('.m-cart-icon-bubble')].filter(isVisible);
    return icons.find(inViewport) || null;
  }

  const CONTAINERS = [
    '[data-slide]',
    '.c-bundle__card',
    '.c-kitbuilder__item',
    '.c-fbt',
    '.c-colors__sheet',
    '.m-product-card',
    '.m-product-quickview',
    'product-info',
    '.m-product-info',
    '.shopify-section',
  ].join(',');

  function sourceImage(from) {
    let start = from instanceof Element ? from : null;
    if (!start && lastTap && Date.now() - lastTapAt < 15000) start = lastTap;
    if (!start) return null;
    let box = start.closest(CONTAINERS);
    while (box) {
      const img = [...box.querySelectorAll('img')].find((i) => isVisible(i) && inViewport(i) && i.getBoundingClientRect().width > 30);
      if (img) return img;
      box = box.parentElement ? box.parentElement.closest(CONTAINERS) : null;
    }
    return null;
  }

  let toastEl = null;
  let toastTimer = null;

  function openDrawer() {
    const drawer = document.querySelector('m-cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
  }

  function toast() {
    const strings = window.CVayveCartFxStrings || {};
    if (strings.show === false) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'c-cartfx-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.innerHTML =
        '<span class="c-cartfx-toast__icon" aria-hidden="true"></span>' +
        '<span class="c-cartfx-toast__text"></span>' +
        '<button type="button" class="c-cartfx-toast__btn"></button>';
      toastEl.querySelector('.c-cartfx-toast__btn').addEventListener('click', () => {
        hideToast();
        openDrawer();
      });
      document.body.appendChild(toastEl);
    }
    toastEl.querySelector('.c-cartfx-toast__text').textContent = strings.added || 'Added to cart';
    toastEl.querySelector('.c-cartfx-toast__btn').textContent = strings.view || 'View cart';
    clearTimeout(toastTimer);
    requestAnimationFrame(() => toastEl.classList.add('is-shown'));
    toastTimer = setTimeout(hideToast, 4000);
  }

  function hideToast() {
    if (toastEl) toastEl.classList.remove('is-shown');
  }

  function bump(icon) {
    if (!icon) return;
    icon.classList.remove('c-cartfx-bump');
    // Restart the animation.
    void icon.offsetWidth;
    icon.classList.add('c-cartfx-bump');
    setTimeout(() => icon.classList.remove('c-cartfx-bump'), 700);
  }

  // Theme product forms: launch the flying thumbnail the moment Add to cart is tapped,
  // then only bump the icon and show the toast when the cart has confirmed the add.
  let earlyAt = 0;
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!shouldFly()) return;
    const btn = form.querySelector('[name="add"]') || form;
    early(btn);
  }, true);

  function fly(from) {
    const icon = cartIcon();
    if (earlyAt && Date.now() - earlyAt < 6000) {
      earlyAt = 0;
      bump(icon);
      toast();
      return;
    }
    if (!ghostFly(from, () => bump(icon))) bump(icon);
    toast();
  }

  // Animate a thumbnail of the product to the cart icon. Returns false when it cannot run.
  function ghostFly(from, onDone) {
    const icon = cartIcon();
    const img = sourceImage(from);
    if (!icon || !img || reduced() || typeof Element.prototype.animate !== 'function') return false;
    const a = img.getBoundingClientRect();
    const b = icon.getBoundingClientRect();
    const size = Math.min(a.width, a.height, 160);
    const ghost = document.createElement('div');
    ghost.className = 'c-cartfx-ghost';
    ghost.style.width = size + 'px';
    ghost.style.height = size + 'px';
    ghost.style.left = a.left + a.width / 2 - size / 2 + 'px';
    ghost.style.top = a.top + a.height / 2 - size / 2 + 'px';
    ghost.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
    document.body.appendChild(ghost);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2);
    const dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const end = Math.max(0.12, 24 / size);
    const anim = ghost.animate(
      [
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: `translate(${dx * 0.45}px, ${dy * 0.45 - 60}px) scale(0.6)`, opacity: 1, offset: 0.5 },
        { transform: `translate(${dx}px, ${dy}px) scale(${end})`, opacity: 0.4 },
      ],
      { duration: 750, easing: 'cubic-bezier(0.45, 0, 0.25, 1)', fill: 'forwards' }
    );
    const done = () => {
      ghost.remove();
      if (onDone) onDone();
    };
    anim.onfinish = done;
    anim.oncancel = done;
    return true;
  }

  function shouldFly() {
    const s = window.MinimogSettings || {};
    if (!s.enable_cart_drawer) return false;
    if (document.querySelector('m-cart-drawer.m-cart-drawer--active')) return false;
    return (s.c_atc_action || 'fly') === 'fly';
  }

  // Start the flying thumbnail right away (before the cart has answered); the later fly() call
  // then only bumps the icon and shows the toast.
  function early(from) {
    if (!shouldFly()) return;
    earlyAt = Date.now();
    ghostFly(from);
    // The thumbnail has landed: stop the button's loading look instead of waiting for the
    // server (the button stays disabled until the cart answers, so it cannot double-add).
    setTimeout(() => settle(from), 750);
  }

  function settle(el) {
    if (!(el instanceof Element)) return;
    [el, el.closest('.m-spinner-loading'), el.closest('[aria-busy="true"]')].forEach((node) => {
      if (!node) return;
      node.classList.remove('m-spinner-loading', 'is-loading');
      node.removeAttribute('aria-busy');
    });
  }

  window.CVayveCartFx = { fly, shouldFly, toast, early };

  /*
   * App product cards (FoxKit "Customers also bought"): FoxKit shows the variant's own
   * image, which for some products is a small swatch chip. Swap in the variant's product
   * photo from the theme (sections/custom-variant-image-map.liquid).
   */
  const mapCache = {};
  function variantMap(handle) {
    if (!mapCache[handle]) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      mapCache[handle] = fetch(`${root}products/${handle}?section_id=custom-variant-image-map`)
        .then((r) => (r.ok ? r.text() : ''))
        .then((html) => {
          const m = html.match(/<script[^>]*data-c-vimg-map[^>]*>([\s\S]*?)<\/script>/);
          return m ? JSON.parse(m[1]) : {};
        })
        .catch(() => ({}));
    }
    return mapCache[handle];
  }

  function drawerClosed(card) {
    const drawer = card.closest('m-cart-drawer');
    return !!drawer && !drawer.classList.contains('m-cart-drawer--active');
  }

  async function fixCard(card) {
    if (drawerClosed(card)) return;
    const link = card.querySelector('a[href*="/products/"]');
    const img = card.querySelector('img');
    const idEl = card.querySelector('[name="id"]');
    if (!link || !img || !idEl || !idEl.value) return;
    const handle = (link.getAttribute('href').split('/products/')[1] || '').split(/[?#/]/)[0];
    if (!handle) return;
    const map = await variantMap(handle);
    const url = map[String(idEl.value)];
    if (!url) return;
    const abs = url.startsWith('//') ? 'https:' + url : url;
    if (img.getAttribute('src') !== abs) {
      img.dataset.cFixed = abs;
      img.removeAttribute('srcset');
      img.setAttribute('src', abs);
    }
  }

  // FoxKit upsell line "You will get 5% OFF on each product" reads like a whole-cart
  // discount; reword it so it is clear the discount is only on the item added from there.
  function fixUpsellMessage(scope) {
    const tpl = (window.CVayveCartFxStrings || {}).upsell;
    if (!tpl) return;
    (scope || document).querySelectorAll('.f-upsell__discount > span:not([data-c-done])').forEach((span) => {
      const strong = span.querySelector('strong');
      const value = strong ? strong.textContent.replace(/\s*off\s*$/i, '').trim() : '';
      if (!value) return;
      const esc = (t) => t.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const parts = tpl.split('{discount}');
      span.innerHTML = parts.map(esc).join('<strong>' + esc(value) + '</strong>');
      span.setAttribute('data-c-done', '');
    });
  }

  const CARD = 'foxkit-product-card, .f-incart__product';
  function fixAll(scope) {
    (scope || document).querySelectorAll(CARD).forEach((c) => fixCard(c));
  }

  document.addEventListener('change', (e) => {
    const card = e.target.closest && e.target.closest(CARD);
    if (card) setTimeout(() => fixCard(card), 60);
  });

  const watch = new MutationObserver((list) => {
    const cards = new Set();
    list.forEach((m) => {
      const el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      const card = el && el.closest && el.closest(CARD);
      if (card) cards.add(card);
      m.addedNodes && m.addedNodes.forEach((n) => {
        if (n.nodeType === 1) {
          if (n.matches && n.matches(CARD)) cards.add(n);
          n.querySelectorAll && n.querySelectorAll(CARD).forEach((c) => cards.add(c));
        }
      });
    });
    fixUpsellMessage();
    cards.forEach((c) => {
      const img = c.querySelector('img');
      if (img && img.dataset.cFixed && img.getAttribute('src') === img.dataset.cFixed) return;
      fixCard(c);
    });
  });
  const startWatch = () => {
    watch.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    const drawer = document.querySelector('m-cart-drawer');
    if (drawer) {
      new MutationObserver(() => {
        if (drawer.classList.contains('m-cart-drawer--active')) fixAll(drawer);
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    fixAll();
    fixUpsellMessage();
  };
  if (document.body) startWatch();
  else document.addEventListener('DOMContentLoaded', startWatch);

  /* Product page sticky add to cart: show the quantity on the button when it is more than 1
     (the quantity box is hidden on phones), e.g. "Add to cart (3)". */
  function stickyLabel() {
    const sticky = document.querySelector('sticky-atc');
    if (!sticky) return;
    const span = sticky.querySelector('.m-add-to-cart--text');
    const input = sticky.querySelector('input[name="quantity"]');
    if (!span || !input) return;
    const base = span.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
    const q = parseInt(input.value, 10) || 1;
    span.textContent = q > 1 ? base + ' (' + q + ')' : base;
  }
  window.addEventListener('syncProductQuantity', () => setTimeout(stickyLabel, 0));
  document.addEventListener('variant:changed', () => setTimeout(stickyLabel, 50));

  /* Cart drawer titles: 2-line clamp, first tap expands. */
  document.addEventListener('click', (e) => {
    const title = e.target.closest && e.target.closest('m-cart-drawer .m-cart-item__title');
    if (!title || title.classList.contains('is-expanded')) return;
    if (title.scrollHeight > title.clientHeight + 1) {
      e.preventDefault();
      title.classList.add('is-expanded');
    }
  });
})();
